import { NavLink, useNavigate } from "react-router-dom";
import { Package, Camera, Inbox, LayoutDashboard, Settings, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Stock", icon: Package, testid: "nav-inventory-tab", end: true },
  { to: "/add", label: "Add Mac", icon: Camera, testid: "nav-scan-add-tab" },
  { to: "/enquiries", label: "Enquiries", icon: Inbox, testid: "nav-enquiries-tab" },
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard-tab" },
  { to: "/settings", label: "Settings", icon: Settings, testid: "nav-settings-tab" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      {/* top bar */}
      <header className="mf-glass fixed top-0 left-0 right-0 z-40 border-b border-white/10">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <div className="flex items-baseline gap-2">
            <span className="text-xl font-extrabold tracking-tight">MacFreaks</span>
            <span className="text-xs font-medium text-[#2997ff]">Hub</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right leading-tight">
              <div className="text-xs font-semibold">{user?.name}</div>
              <div className="text-[10px] uppercase tracking-wide text-[#98989d]">{user?.role}</div>
            </div>
            <button
              data-testid="logout-button"
              onClick={async () => { await logout(); navigate("/login"); }}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-[#98989d] transition-colors hover:text-white active:scale-95"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 pb-28 pt-20">{children}</main>

      {/* bottom nav */}
      <nav className="mf-glass fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 pb-[env(safe-area-inset-bottom)]">
        <div className="mx-auto grid max-w-5xl grid-cols-5">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `flex min-h-[60px] flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors ${
                    isActive ? "text-[#2997ff]" : "text-[#98989d]"
                  }`
                }
              >
                {n.to === "/add" ? (
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#2997ff] text-white shadow-lg shadow-[#2997ff]/30">
                    <Icon size={18} />
                  </span>
                ) : (
                  <Icon size={20} />
                )}
                {n.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
